import React from 'react';
import ModelViewer from '../Components/Layout/ModelViewer';
import Quote from '../Components/Common/Quote';
import './Home.css'
import DotGrid from '../Components/Layout/DotGrid';
import HeroImg from '../Assets/Hero.png'
import Model1 from '../Assets/Models/Statue.glb'
import StartQuote from '../Assets/StartQuote.svg'
import EndQuote from '../Assets/EndQuote.svg'
import Pillar1 from '../Assets/Pillar.png'
import ScreenSlider from '../Components/Layout/ScreenSlider';
import Footer from '../Components/Layout/Footer';
import SizeErrorScreen from '../Components/Layout/ResponsiveError';
import Preloader from '../Components/Layout/Preloader';




const Home = () => {
    return ( 
        <>  
                <Preloader />
                <SizeErrorScreen />
            
            <section className='Hero'>
                <div style={{ width: '100%', height: '100vh', position: 'absolute', boxSizing: 'border-box', zIndex: '0' }}>
                <DotGrid
                    dotSize={5}
                    gap={15}
                    baseColor="#311010"
                    activeColor="#ff4f4f"
                    proximity={120}
                    shockRadius={250}
                    shockStrength={5}
                    resistance={750}
                    returnDuration={1.5}
                />
                </div>
                <img className='HeroImg' src={HeroImg} alt="" />
            </section>

            <section className='Quote'>

                <div className='QuoteBlock'>
                    <img src={StartQuote} alt="" />
                    <Quote
                        baseOpacity={0.1}
                        enableBlur
                        baseRotation={10}
                        blurStrength={6}
                        >
                        There will be no end to the troubles of states, or of humanity itself, till philosophers become kings in this world, or till those we now call kings and rulers really and truly become philosophers, and political power and philosophy thus come into the same hands.
                    </Quote>
                    <img src={EndQuote} alt="" />
                </div>

                <ModelViewer
                    url={Model1}
                    width={600}
                    height={600}
                    modelXOffset={0.3}
                    modelYOffset={-0.7}
                    enableMouseParallax
                    enableHoverRotation
                    enableManualZoom={false}
                    environmentPreset="forest"
                    fadeIn={false}
                    autoRotate={false}
                    autoRotateSpeed={0.35}
                    showScreenshotButton={false}
                    />
            </section>

            <section className='History'>
                <img className='Pillar1' src={Pillar1} alt="" />
                <div className='HistoryGrid' style={{ width: '100%', height: '100vh', position: 'absolute', boxSizing: 'border-box', zIndex: '0' }}>
                <DotGrid
                    dotSize={5}
                    gap={15}
                    baseColor="#cfcfcf"
                    activeColor="#262626"
                    proximity={120}
                    shockRadius={250}
                    shockStrength={5}
                    resistance={750}
                    returnDuration={1.5}
                />
                </div>
                <img className='Pillar2' src={Pillar1} alt="" />

                <ScreenSlider />
                
            </section>

            <Footer />
        </>
     );
}
 
export default Home;